var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "record" }, [
    _c("p", { staticClass: "record__title title" }, [
      _vm.record.grn_date
        ? _c("span", { staticClass: "title__date" }, [
            _vm._v(_vm._s(_vm.record.grn_date)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.record.grn
        ? _c("span", { staticClass: "title__number" }, [
            _vm._v("ГРН: " + _vm._s(_vm.record.grn)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.record.author
      ? _c("p", { staticClass: "record__author" }, [
          _c("b", [_vm._v("Регистрирующий орган:")]),
          _vm._v(" " + _vm._s(_vm.record.author)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.record.type
      ? _c("p", { staticClass: "record__type" }, [
          _c("b", [_vm._v("Вид изменения:")]),
          _vm._v(" " + _vm._s(_vm.record.type)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isCertificate
      ? _c("p", [
          _c("b", [_vm._v("Свидетельство:")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.record.sv.s +
                  " " +
                  _vm.record.sv.n +
                  " от " +
                  _vm.record.sv.d
              )
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.record.docs.length > 0
      ? _c("div", { staticClass: "record_docs docs" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "docs__list" },
            _vm._l(_vm.record.docs, function (d, i) {
              return _c("li", { key: i, staticClass: "docs__item" }, [
                _vm._v(_vm._s(d.name)),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "docs__title" }, [
      _c("b", [_vm._v("Документы:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }